import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    
    // Log error to console in development
    if (process.env.NODE_ENV === 'development') {
      console.error('Error caught by boundary:', error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-hsa-black flex items-center justify-center p-8">
          <div className="text-center max-w-2xl">
            <div className="w-24 h-24 bg-acid-green from-acid-green to-acid-green rounded-full flex items-center justify-center mx-auto mb-8">
              <span className="text-4xl">⚠️</span>
            </div>
            <h1 className="text-3xl font-bold text-white mb-4">
              Oups ! Quelque chose s'est mal passé
            </h1>
            <p className="text-white/70 text-lg mb-8">
              Nous nous excusons pour ce désagrément. Notre équipe technique a été notifiée.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="px-8 py-4 bg-acid-green from-acid-green to-acid-green text-white font-semibold rounded-2xl hover:scale-105 transition-transform duration-300"
            >
              Recharger la page
            </button>
            
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <details className="mt-8 text-left text-white/50">
                <summary className="cursor-pointer text-acid-green">Détails techniques (Dev)</summary>
                <pre className="mt-4 p-4 bg-hsa-dark rounded-lg overflow-auto text-sm">
                  {this.state.error && this.state.error.toString()}
                  <br />
                  {this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
